import { render, staticRenderFns } from "./InscripcionPage.vue?vue&type=template&id=0798fe62"
import script from "./InscripcionPage.js?vue&type=script&lang=js&external"
export * from "./InscripcionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports